import { ReciboEstado } from 'src/utils/enums/ReciboEstado';
import { ReciboFormState } from './types';
import { colorMapping } from 'src/utils/enums/ReciboEstado';
import { marcarEnviadoReciboF, marcarRecepcionadoReciboF } from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';
const initialState: ReciboFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
  productos: null,
};

const formSlice = createSlice({
  name: 'reciboForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: ReciboEstado.Borrador,
        text: ReciboEstado[ReciboEstado.Borrador].toUpperCase(),
        color: colorMapping[ReciboEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadoReciboF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al recibo como enviado',
        },
        marcarRecepcionadoReciboF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar al recibo como recepcionado',
        },
      };
      state.data = {
        clienteId: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar orden',
        },
        nro: { readOnly: true },
        nroOcCliente: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar orden',
        },
        nroProveedor: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar orden',
        },
      };
    },
    setFormStatusEnviado(state) {
      state.status = {
        id: ReciboEstado.Enviado,
        text: ReciboEstado[ReciboEstado.Enviado].toUpperCase(),
        color: colorMapping[ReciboEstado.Enviado],
      };
      state.actions = {
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadoReciboF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar al recibo como enviado',
        },
        marcarRecepcionadoReciboF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al recibo como recepcionado',
        },
      };
    },
    setFormStatusRecepcionado(state) {
      state.status = {
        id: ReciboEstado.Recepcionado,
        text: ReciboEstado[ReciboEstado.Recepcionado].toUpperCase(),
        color: colorMapping[ReciboEstado.Recepcionado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadoReciboF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al recibo como enviado',
        },
        marcarRecepcionadoReciboF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al recibo como recepcionado',
        },
      };
    },
    setModifyingProducts(state) {
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadoReciboF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar al recibo como enviado',
        },
        marcarRecepcionadoReciboF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar al recibo como recepcionado',
        },
      };
    },
    setModifyingProductsFinished(state) {
      // Restaurar estado anterior
      state.status = state.previousState!.status;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(marcarEnviadoReciboF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarEnviadoReciboF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarRecepcionadoReciboF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarRecepcionadoReciboF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.recibo.form.status;

export const selectMarcarEnviadoReciboF = (state: RootState) =>
  state.recibo.form.actions?.marcarEnviadoReciboF;

export const selectMarcarRecepcionadoReciboF = (state: RootState) =>
  state.recibo.form.actions?.marcarRecepcionadoReciboF;

export const selectGuardar = (state: RootState) =>
  state.recibo.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusBorrador,
  setFormStatusEnviado,
  setFormStatusRecepcionado,
  setModifyingProducts,
  setModifyingProductsFinished,
} = formSlice.actions;

export default formSlice.reducer;
